export async function initMocks() {
  const [
    { default: orgClient },
    { default: engineClient },
    { default: communicatorClient },
    { registerApiMock }
  ] = await Promise.all([
    import('@/services/amio/amio-org.http-client'),
    import('@/services/amio/amio.http-client'),
    import('@/services/amio/amio-communicator.http-client'),
    import('@/services/amio/runtime-mocks/register-api-mock')
  ])

  registerApiMock(orgClient, 'org')
  registerApiMock(engineClient, 'engine')
  registerApiMock(communicatorClient, 'communicator')
}
